import React from 'react';

import { ErrorMessage as FormikErrorMessage } from 'formik';
import Alert from 'components/alert';

import './style.css';

const ErrorMessage = (props) => {
  return (
    <FormikErrorMessage {...props}>
      {(msg) => <Alert type="error" message={msg} className="error-message" />}
    </FormikErrorMessage>
  );
};

export default ErrorMessage;
